import {
  useRealtimeLiveRoomStateScope,
  useRealtimePresenceRoomScope,
} from "@utils/realtime/activeScopes";

export function useLiveRoomRealtime(
  accessId: string | null | undefined,
  enabled = true,
) {
  const active = enabled && !!accessId;
  useRealtimeLiveRoomStateScope(accessId ?? "", active);
  useRealtimePresenceRoomScope(accessId ?? "", active);
}
